import APIS from 'constants/api'
// import { LoaderContext } from 'context/loader'
import { SnackBarContext } from 'context/SnackBarContext'
import usePost from 'hooks/usePost'
import { useContext, useState, createContext } from 'react'

/* eslint-disable @typescript-eslint/no-explicit-any */
interface IWishlist {
  wishlistIdData: any
  cartIdData: any
  setWishlistIdData: (val: any) => void
  setCartIdData: (val: any) => void
  handleAddWishlist: (productId: string) => Promise<void>
  handleRemoveWishlist: (productId: string) => Promise<void>
}

const DefaultValues = {
  wishlistIdData: [],
  cartIdData: [],
  setWishlistIdData: () => null,
  setCartIdData: () => null,
  handleAddWishlist: async () => {
    // Default implementation returning a resolved promise
    return Promise.resolve()
  },
  handleRemoveWishlist: async () => {
    // Default implementation returning a resolved promise
    return Promise.resolve()
  },
}

const WishListContext = createContext<IWishlist>(DefaultValues)

const WishListProvider = ({ children }: { children: React.ReactNode }) => {
  const [wishlistIdData, setWishlistIdData] = useState([])
  const [cartIdData, setCartIdData] = useState([])
  const { setShowSnackBar } = useContext(SnackBarContext)
  // const { setLoader } = useContext(LoaderContext)
  const { mutateAsync } = usePost()
  const customerId = localStorage.getItem('customerId') || false

  const handleAddWishlist = async (productId: string): Promise<void> => {
    //setLoader(true)
    try {
      const res = await mutateAsync({
        url: APIS.ADD_WISHLIST,
        payload: {
          customerId: customerId,
          productId: [productId],
        },
      })
      if (res) {
        //setLoader(false)
        setShowSnackBar({ open: true, message: `${res?.m}`, severity: '' })
        setWishlistIdData((prev) => ({ ...prev, [productId]: true }))
      }
    } catch (error) {
      //setLoader(false)

      setShowSnackBar({ open: true, message: `${error}`, severity: '' })
    }
  }

  const handleRemoveWishlist = async (productId: string): Promise<void> => {
    //setLoader(true)
    try {
      const res = await mutateAsync({
        url: APIS.REMOVE_FROM_WISHLIST,
        payload: {
          customerId: customerId,
          productId: productId,
        },
      })
      if (res) {
        //setLoader(false)
        setShowSnackBar({ open: true, message: `${res?.m}`, severity: '' })
        setWishlistIdData((prev) => ({ ...prev, [productId]: false }))
      }
    } catch (error) {
      //setLoader(false)
      setShowSnackBar({ open: true, message: `${error}`, severity: '' })
    }
  }

  return (
    <WishListContext.Provider
      value={{ wishlistIdData, setWishlistIdData, cartIdData, setCartIdData, handleAddWishlist, handleRemoveWishlist }}
    >
      {children}
    </WishListContext.Provider>
  )
}

export default WishListProvider

export const useWishListContext = () => {
  return useContext(WishListContext)
}
